import { render, staticRenderFns } from "./EditClient.vue?vue&type=template&id=23c423c9&scoped=true"
import script from "./EditClient.vue?vue&type=script&lang=js"
export * from "./EditClient.vue?vue&type=script&lang=js"
import style0 from "./EditClient.vue?vue&type=style&index=0&id=23c423c9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23c423c9",
  null
  
)

export default component.exports